module.exports = __webpack_public_path__ + "fransa mutfak 10.jpg?977a580273877992c03266825ad02252";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 10.jpg
// module id = 340
// module chunks = 0